import request from '@/utils/request'


// 查询视频打赏中奖记录列表
export function listRewardPrizeLog(query) {
  return request({
    url: '/video/reward/prize/log/list',
    method: 'get',
    params: query
  })
}

// 查询视频打赏中奖记录分页
export function pageRewardPrizeLog(query) {
  return request({
    url: '/video/reward/prize/log/page',
    method: 'get',
    params: query
  })
}

// 查询视频打赏中奖记录详细
export function getRewardPrizeLog(data) {
  return request({
    url: '/video/reward/prize/log/detail',
    method: 'get',
    params: data
  })
}

// 新增视频打赏中奖记录
export function addRewardPrizeLog(data) {
  return request({
    url: '/video/reward/prize/log/add',
    method: 'post',
    data: data
  })
}

// 修改视频打赏中奖记录
export function updateRewardPrizeLog(data) {
  return request({
    url: '/video/reward/prize/log/edit',
    method: 'post',
    data: data
  })
}

// 删除视频打赏中奖记录
export function delRewardPrizeLog(data) {
  return request({
    url: '/video/reward/prize/log/delete',
    method: 'post',
    data: data
  })
}
